import Fetch from 'utils/fetch'
import { generateQueryParams } from '../../../utils/custom-functions'

export const getOrders = (params) =>
  Fetch.get(`/orders:cards-paginated?${generateQueryParams(params)}`).then(({ data }) => data)
